import { render, staticRenderFns } from "./MarkdownRenderer.vue?vue&type=template&id=bc2c946c&"
import script from "./MarkdownRenderer.vue?vue&type=script&lang=js&"
export * from "./MarkdownRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports